<!--
 * @Description:
 * @version:
 * @Author: huhuan
 * @Date: 2021-04-26 14:43:30
 * @LastEditors: huhuan
 * @LastEditTime: 2022-11-04 10:53:51
-->
<template>
  <div>
    <m-input v-model="postData.userName" placeholder="请输入"></m-input>
    <m-input v-model="postData.password" placeholder="请输入"></m-input>
    <m-button type="primary" @click="handlerLogin">登录</m-button>
  </div>
</template>

<script>
import { RSAencrypt } from '@/utils/rsaUtils'

export default {
  components: {},

  computed: {},
  data() {
    return {
      postData: {
        userName: '',
        password: ''
      }
    }
  },
  created() {},
  methods: {
    /**
     * @Description: 登录
     * @return {*}
     */
    handlerLogin() {
      this.fetchLoginV2().then(res => {
        console.log('res', res)
        this.$store.commit('setToken', res)
        this.$router.push({
          path: '/'
        })
      })
    },
    /**
     * @Description: 登录
     * @return {*}
     */
    fetchLoginV2() {
      return this.$httpPut('accountLoginNew', {
        password: RSAencrypt(this.postData.password), // md5(md5(输入密码)+当前时间戳)
        accountName: this.postData.userName, // 用户名/手机号
        cryptoFlag: 1
      })
    }
  }
}
</script>
<style scoped lang="scss"></style>
